<template>
    <div class="col-12 nopads">
        <span class="card-title">{{ campaign.name}}</span>
        <span class="span-title center">{{$tc('payment.confirm_subscription_donation',plan.amount/100)}}</span>
        <div class="center">
            <i :class="getCardIcon(card.card.brand)"></i>
            <span class="pl-2">{{'•••'+card.card.last4}}</span>
        </div>
        <div class="col-sm-12 center pt-4">
            <b-button
                    variant="outline-danger fair-button-outline"
                    :disabled="loading"
                    @click.stop="$emit('close')"
            >
                {{ $t('common.cancel') }}
            </b-button>
            <b-button
                    variant="outline-info fair-button-outline"
                    :disabled="loading"
                    @click.stop="confirmSubscription"
            >
                {{ $t('common.confirm') }}
            </b-button>
        </div>
        <div
                v-if="loading"
                id="loader"
                class="spinner"
        />
    </div>
</template>

<script>
    import FairApi from "../../modules/api";
    import {cardHelper} from "../../mixins/CardMixin";

    export default {
        name: "subscription-off-session-payment",
        mixins: [cardHelper],
        data() {
            return {
                stripe: null,
                loading: false,
            }
        },

        props: {
            card: {
                type: Object,
                required: true
            },
            campaign: {
                type: Object,
                required: true
            },
            plan: {
                type: Object,
                required: true
            }
        },

        created() {
            // eslint-disable-next-line no-undef
            this.stripe = Stripe(process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY)
        },

        methods: {
            confirmSubscription: function () {
                this.loading = true
                FairApi.post(FairApi.subscriptionPaymentOffSession(this.campaign.id, this.plan.planId),
                    {}, this.createSubscriptionSuccess, this.createSubscriptionFailed)
            },

            createSubscriptionSuccess: function (response) {
                if (response.success) {
                    this.onSubscriptionSuccess()
                } else if (response.error === 'requires_action') { // This card requires further authentication
                    this.stripe.confirmCardPayment(response.clientSecret, {
                        payment_method: response.paymentMethod
                    }).then(this.handleCardAuthenticationResult);
                }
            },

            handleCardAuthenticationResult: function (result) {
                if (result.error) { // Authentication failed
                    this.loading = false
                    this.$emit('alert', result.error.message)
                } else {
                    if (result.paymentIntent.status === 'succeeded') {
                        this.onSubscriptionSuccess()
                    }
                }
            },

            createSubscriptionFailed: function () {
                this.loading = false
                this.$emit('alert', this.$t("payment.off_session_payment_failed"))
            },

            onSubscriptionSuccess: function () {
                this.$router.push({name: 'subscription-success-view', query: {session_id: "success"}})
            }
        }
    }
</script>

